import request from '@/utils/request'

export function getAll(page_size, currentPage, code, reference) {
  return request({
    url: 'product/getAll/' + page_size +'/' + code + '/' + reference +  '?page=' + currentPage,
    method: 'get'
  })
}

export function search(query, branchId = null, typeDocument = null) {
  return request({
    url: 'product/search/' + query + '/' + branchId + '/' + typeDocument,
    method: 'get'
  })
}

export function edit(id) {
  return request({
    url: 'product/edit/' + id,
    method: 'get'
  })
}

export function store(data) {
  return request({
    url: 'product/save',
    method: 'post',
    headers: {
      'content-type': "multipart/form-data",
    },
    data
  })
}

export function storeVariations(data) {
  return request({
    url: 'product/save',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: 'product/update',
    method: 'post',
    headers: {
      'content-type': "multipart/form-data",
    },
    data
  })
}

export function destroy(id) {
  return request({
    url: 'product/destroy/' + id,
    method: 'delete'
  });
}

export function printLabels(data) {
  return request({
    url: 'product/printLabels',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

export function storeFile(data) {
  return request({
    url: 'product/storeFile',
    method: 'post',
    headers: {
      'content-type': "multipart/form-data",
    },
    data
  })
}

export function getLocationsById(id, branchId) {
  return request({
    url: 'product/getLocationsById/' + id + '/' + branchId,
    method: 'get'
  })
}

export function getUnitMeasurement() {
  return request({
    url: 'product/getUnitMeasurement',
    method: 'get'
  })
}